import {ComponentFactory, ComponentFactoryResolver, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarraPesquisaComponent } from './barra-pesquisa.component';
import {MatIconModule} from '@angular/material/icon';
import {PaginatorModule} from 'primeng/paginator';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProcessoConsultivoComponent} from '../../../app/main/apps/processo/processo-consultivo.component';
import {RouterModule} from '@angular/router';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '../../../../../@cdk/angular/material';
import {MatInputModule} from '@angular/material/input';
import {
    CdkProcessoSearchAutocompleteModule
} from '../../../../../@cdk/components/processo/cdk-processo-search-autocomplete/cdk-processo-search-autocomplete.module';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule} from '@angular/material/form-field';
import {
    CdkProcessoAutocompleteModule
} from '../../../../../@cdk/components/processo/cdk-processo-autocomplete/cdk-processo-autocomplete.module';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';



@NgModule({
  declarations: [
    BarraPesquisaComponent
  ],
    imports: [
        CommonModule,
        MatIconModule,
        PaginatorModule,
        ReactiveFormsModule,

        RouterModule,

        MatDialogModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,

        CdkProcessoAutocompleteModule,
        MatMenuModule,
        MatTooltipModule,
        FormsModule
    ]
})
export class BarraPesquisaModule {
    constructor(private resolver: ComponentFactoryResolver) {}

    public resolveComponentFactory(): ComponentFactory<BarraPesquisaComponent> {
        return this.resolver.resolveComponentFactory(BarraPesquisaComponent);
    }
}
